import Vue from 'vue'
import urls from '../services.url.js'
import authHeaders from './headers'

export default {
  cropImage (filename, top, left, width, height) {
    let body = JSON.stringify({ filename, top, left, width, height })
    let target = urls.CROP_URL
    return Vue.http.post(target, body, {'headers': authHeaders.getAuthHeaders()})
  },
  binaryUpload (payload, filename) {
    let body = JSON.stringify({ payload, filename })
    let target = urls.BINARY_UPLOAD_URL
    return Vue.http.post(target, body, {'headers': authHeaders.getAuthHeaders()})
  },
  getAllThumbnails () {
    let url = urls.LIST_IMAGE_URL
    return Vue.http.get(url)
  },
  listImages (type, size, page, pagesize) {
    let url = urls.LIST_IMAGE_URL
    if (type || size || page) {
      url = url + '?'
    }
    if (type) {
      url = url + 'type=' + type + ';'
    }
    if (size) {
      url = url + 'size=' + size + ';'
    }
    if (page) {
      url = url + 'page=' + page + ';'
    }
    if (pagesize) {
      url = url + 'pagesize=' + pagesize + ';'
    }
    return Vue.http.get(url, {'headers': authHeaders.getAuthHeaders()})
  }
}



// WEBPACK FOOTER //
// ./src/api/real-api/img.api.js